// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b20cc3{align-items:stretch}*+.b20cc3{margin-top:1em}.b20cc3 figure{position:relative}._7149e6{visibility:hidden}._895dc2{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;border-radius:.25em}", ""]);
// Exports
exports.locals = {
	"gallery": "b20cc3",
	"placeholder": "_7149e6",
	"image": "_895dc2"
};
module.exports = exports;
